<template>
    <div>
        <div class="contact" v-if="formData" @click.capture="checkAuthentice">
            <div class="board-title">其他联系方式</div>
            <veui-button v-if="!isModify"  class="modify-btn" ui="primary" @click="isModify = !isModify ">修改信息</veui-button>
            <veui-form :data="formData" ref="form" :validators="validators" :class="{isViewModel: !isModify}">
                <veui-field
                    name="email"
                    label="电子邮箱"
                    >
                    <veui-input v-if="isModify"  v-model="formData.email"/>
                    <div v-else>{{formData.email}}</div>
                </veui-field>
                <veui-field
                    name="wechat_qr_code"
                    label="微信二维码"
                    >
                    <veui-uploader
                        v-if="isModify && !isloading"
                        accept="image/*"
                        :extensions="['jpg','png','jpeg']"
                        @change="res => uploaderChange(res, 'wechat_qr_code')"
                        :value="!this.formData.wechat_qr_code ? null : ({'src': this.formData.wechat_qr_code})"
                        :max-count="1"
                        :convert-response="(data) => convertResponse(data, 'wechat_qr_code')"
                        type="image"
                        :action="`${url}&bucketName=law_smart&storeDir=wechat_qr_code&ajax=true`"
                        ui="s"
                        >
                    </veui-uploader>
                    <div class="img-wrapper" v-if="!isModify && this.formData.wechat_qr_code">
                        <img class="viewimg img" :src="this.formData.wechat_qr_code" alt="">
                    </div>
                    <div v-if="!isModify && !this.formData.wechat_qr_code">无</div>
                </veui-field>
                <div class="info" v-if="isModify"> 
                    <div>上传微信二维码</div>
                </div>
            </veui-form>
        </div>
        <div class="submit"  v-if="isModify">
            <veui-button ui="primary"  @click="postData('contact')">保存</veui-button>
            <veui-button class="submit-cancle" @click="cancle">取消</veui-button>
        </div>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @author baoleilei
 * @desc 其他联系方式
 */
import isBoolean from 'lodash/isBoolean';
import {Button, Form, Field, Input, Uploader} from 'veui';
import mixinajax from '@/mixins/ajax';
import mixinauthentice from '@/mixins/authentice';
import {mapState, mapActions} from 'vuex';

const url = {
    // 用户管理列表
    userInfo: 'law:/themis/law/user/info',
    save: 'law:/themis/law/user/save'
};


export default {
    name: 'contact',
    mixins: [mixinajax, mixinauthentice],
    components: {
        'veui-button': Button,
        'veui-field': Field,
        'veui-form': Form,
        'veui-input': Input,
        'veui-uploader': Uploader
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew
        })
    },
    watch: {
        userInfoNew: {
            handler(val) {
                if (val) {
                    this.updateModify(val);
                }
            },
            deep: true
        }
    },
    data() {
        return {
            isModify: true,
            formData: null,
            isloading: true,
            validators: [
                {
                    fields: ['email'],
                    validate(email) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                if (email
                                && !(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)*.[a-zA-Z0-9]{2,6}$/.test(email))) {
                                    res = {
                                        email: '请输入正确的邮箱'
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    },
                    triggers: ['input']
                }
            ],
            url: `/bp/api/upload?ajax=1&bdstoken=${window._pageData.bdstoken}`
        };
    },
    created() {
        this.getUserInfoNew();
    },
    methods: {
        ...mapActions({
            getUserInfoNew: 'lawStore/getUserInfoNew'
        }),
        convertResponse(data, key) {
            return ({
                success: data && (Number(data.code) === 0),
                src: data && data.data && data.data.bos_url,
                message: data.msg
            });
        },
        uploaderChange(res, key) {
            this.formData[key] = res ? res.src : '';
        },
        postData(op_type) {
            this.$refs.form.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    this.$http.get(url.save, {
                        params: {
                            ... this.formData,
                            op_type
                        }
                    }).then(res => {
                        res = this.$normalizeResponseData(res);
                        if (res) {
                            this.$Message.success(op_type === 'submit' ? '提交成功' : '保存成功!');
                            this.getUserInfoNew();
                        }
                        else {
                            let msg = res.msg ? res.msg : '服务器出错了';
                            this.$spyLogs.sendPluginsError(msg, 'contact');
                        }
                    }).catch(err => {
                        this.$spyLogs.sendPluginsForError(err, url.save, 'contact');
                    });
                }
            });
        },
        cancle() {
            this.isModify = false;
            this.getUserInfoNew();
        },
        getData() {
            this.$http.get(url.userInfo, {}).then(res => {
                if (res) {
                    let data = res;
                    this.formData = data;
                    this.isloading = false;
                    if (this.formData.email || this.formData.wechat_qr_code) {
                        this.isModify = false;
                    }
                }
                else {
                    let msg = res.data.msg ? res.data.msg : '服务器出错了';
                    this.$spyLogs.sendPluginsError(msg, 'contact');
                }
            }).catch(err => {
                this.$spyLogs.sendPluginsForError(err, url.userInfo, 'contact');
            });
        },
        updateModify(info) {
            if (!info) {
                return;
            }
            let {lawyer_info} = info || {};
            this.formData = {
                email: lawyer_info.email,
                wechat_qr_code: lawyer_info.wechat_qr_code
            };
            if (this.formData.email || this.formData.wechat_qr_code) {
                this.isModify = false;
            }
        }
    }
};
</script>

<style lang="stylus" scoped>
.contact 
    padding 24px
    background #ffffff
    border-radius 4px
    .board-title
        font-size: 20px
        color: #282C33
        font-weight 700
    .veui-form
        margin-top 30px
        .info
            margin-left calc(7em + 32px)
            position relative
            top: -20px
            .reupload
                color #0052CC
                cursor pointer

.submit
    padding 24px
    background #ffffff
    margin-top 24px
    border-radius 4px
    .submit-cancle
        margin-left 8px
.modify-btn
    float right
    margin-top -2px
.img-wrapper
    height 120px
    display flex
    align-items center
    margin-right 12px
    border: 1px solid #E2E6F0;
    border-radius: 4px;
    float left
    .img
        border 1px solid rgb(236, 236, 236)
        box-sizing border-box
        width 120px
        
/deep/ .veui-uploader-input-label-image svg    
    background url('../../../assets/img/law/card-emblem.png')
    color transparent
    background-size 100% 100% 

.isViewModel 
    color #282C33
    /deep/ .veui-field-required > .veui-field-label::before
        content: ''
    /deep/ .veui-field-label
        margin-right 12px
    /deep/ .veui-field
        margin-bottom 16px
</style>